(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/private-route/private-route.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/private-route/private-route.js');
"use strict";

const _excluded = ["component"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const {
  Route,
  Redirect
} = svs.app.ReactRouter;
const {
  LOGIN
} = svs.ticket_partner.constants.routes || {};
const PrivateRoute = _ref => {
  let {
      component: Component
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    isLoggedIn
  } = svs.ticket_partner.useUserContext();
  return React.createElement(Route, _extends({
    component: props => {
      if (isLoggedIn) {
        return React.createElement(Component, props);
      }
      return React.createElement(Redirect, {
        to: "".concat(LOGIN, "?returnUrl=").concat(rest.path)
      });
    }
  }, rest));
};
svs.ticket_partner.sharedComponents.privateRoute.PrivateRoute = PrivateRoute;

 })(window);